__turbopack_context__.v({
  "avatar": "review-module-scss-module__bjb3-a__avatar",
  "badge": "review-module-scss-module__bjb3-a__badge",
  "body": "review-module-scss-module__bjb3-a__body",
  "bodyText": "review-module-scss-module__bjb3-a__bodyText",
  "bodyTextExpanded": "review-module-scss-module__bjb3-a__bodyTextExpanded",
  "card": "review-module-scss-module__bjb3-a__card",
  "dateLabel": "review-module-scss-module__bjb3-a__dateLabel",
  "footer": "review-module-scss-module__bjb3-a__footer",
  "footerAction": "review-module-scss-module__bjb3-a__footerAction",
  "header": "review-module-scss-module__bjb3-a__header",
  "headerMeta": "review-module-scss-module__bjb3-a__headerMeta",
  "headerRow": "review-module-scss-module__bjb3-a__headerRow",
  "initials": "review-module-scss-module__bjb3-a__initials",
  "ratingValue": "review-module-scss-module__bjb3-a__ratingValue",
  "reply": "review-module-scss-module__bjb3-a__reply",
  "replyBar": "review-module-scss-module__bjb3-a__replyBar",
  "replyContent": "review-module-scss-module__bjb3-a__replyContent",
  "replyLabel": "review-module-scss-module__bjb3-a__replyLabel",
  "replyText": "review-module-scss-module__bjb3-a__replyText",
  "replyTextExpanded": "review-module-scss-module__bjb3-a__replyTextExpanded",
  "reviewerName": "review-module-scss-module__bjb3-a__reviewerName",
  "star": "review-module-scss-module__bjb3-a__star",
  "starFilled": "review-module-scss-module__bjb3-a__starFilled",
  "stars": "review-module-scss-module__bjb3-a__stars",
  "starsRow": "review-module-scss-module__bjb3-a__starsRow",
  "subtitle": "review-module-scss-module__bjb3-a__subtitle",
  "title": "review-module-scss-module__bjb3-a__title",
});
